export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_10.d4ce038a.jpg";